const times = {
  prefix: 'fas',
  iconName: 'times',
  icon: [384, 512, [], '', 'M20.44 367.51a42.46 42.46 0 0 0 60.05 60.06L192 316.05l111.51 111.51a42.47 42.47 0 0 0 60.06-60.05L252.05 256l111.51-111.51a42.47 42.47 0 0 0-60.05-60.05L192 195.95 80.49 84.44a42.46 42.46 0 1 0-60.05 60.05L131.95 256 20.44 367.51Z']
};

export { times as t };
//# sourceMappingURL=localIcons-EM4gOTGb-DpE3j47V.js.map
